import React, { forwardRef } from 'react';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/solid';

const TextField = forwardRef(
  (
    {
      label,
      name,
      type = 'text',
      placeholder,
      required = false,
      error,
      showPasswordToggle = false,
      showPassword = false,
      onTogglePassword,
      className = '',
      ...rest
    },
    ref,
  ) => {
    const isPasswordField = type === 'password' && showPasswordToggle;

    return (
      <div className="flex flex-col w-full">
        {label && (
          <label
            htmlFor={name}
            className="text-sm mb-1 font-semibold text-gray-900 dark:text-gray-200"
          >
            {label}
            {required && <span className="text-red-500">*</span>}
          </label>
        )}

        <div className="relative">
          <input
            ref={ref}
            id={name}
            name={name}
            type={isPasswordField ? (showPassword ? 'text' : 'password') : type}
            placeholder={placeholder || label}
            className={`w-full px-3 py-2 border rounded-lg 
              dark:bg-gray-700 dark:text-white dark:border-gray-600
              focus:ring-2 focus:ring-blue-500 focus:outline-none
              ${
                error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300'
              } 
              ${className}
              dark:bg-gray-800
             disabled:dark:bg-gray-600 disabled:bg-gray-200`}
            {...rest}
          />

          {isPasswordField && (
            <button
              type="button"
              className="absolute right-3 top-3"
              onClick={onTogglePassword}
              tabIndex="-1"
            >
              {showPassword ? (
                <EyeSlashIcon className="h-4 w-4 text-gray-500" />
              ) : (
                <EyeIcon className="h-4 w-4 text-gray-500" />
              )}
            </button>
          )}
        </div>

        {error && <p className="text-red-500 text-xs mt-1">{error.message}</p>}
      </div>
    );
  },
);

TextField.displayName = 'TextField';

export default TextField;
